import { ReferralPromoCosmicMetadata } from '@finn/ui-cosmic';
import { cn } from '@finn/ui-utils';

import { ReferralPromoContent } from './ReferralPromoContent';
import { ReferralPromoImage } from './ReferralPromoImage';

type ReferralPromoData = ReferralPromoCosmicMetadata & {
  inviteLink?: string;
  isLoading?: boolean;
  error?: any;
};

type Props = {
  data: ReferralPromoData;
};

export const ReferralPromoDesktop = ({ data }: Props) => {
  return (
    <div className="mx-auto my-0 max-w-full overflow-hidden">
      <div
        className="flex w-full justify-end overflow-hidden rounded"
        style={{ backgroundColor: data.color_hex }}
      >
        <div className="min-h-[480px] w-full max-w-full sm:flex sm:min-h-[448px] md:max-h-[860px] md:min-h-[480px]">
          <div
            className={cn(
              'flex min-h-[400px] w-1/2 flex-col px-14 py-24 transition-all',
              {
                'text-black': data.dark_text,
                'text-white': !data.dark_text,
                'order-2': data.reverse,
              }
            )}
          >
            <ReferralPromoContent data={data} />
          </div>

          <div
            className={cn(
              'order-2 h-full w-1/2 overflow-hidden bg-black object-cover',
              {
                'order-1': data.reverse,
              }
            )}
          >
            <ReferralPromoImage
              src={data.image?.url}
              altText={data?.image_alt_text || data.title}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
